export const MANUAL_SIMULATION = 'MANUAL_SIMULATION'
export const REMOTE_SIMULATION = 'REMOTE_SIMULATION'
export const FIRST_PERSON_SIMULATION = 'FIRST_PERSON_SIMULATION'
export const START_DIALOG = 'START_DIALOG'
export const END_DIALOG = 'END_DIALOG'
export const GUIDE_DIALOG = 'GUIDE_DIALOG'
export const CONTENT_TEXT = 'CONTENT_TEXT'
export const CONTENT_BUTTON = 'CONTENT_BUTTON'
export const BUTTON_NEXT_SIMULATION = 'BUTTON_NEXT_SIMULATION'
export const LEVERS_COMPLETE = 'LEVERS_COMPLETE'

